module.exports = __webpack_public_path__ + "img/logo_letras_blancas.a1cee4d6.svg";